import { Component } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';

@Component({
  selector: 'app-helper-center',
  templateUrl: './helper-center.component.html',
  styleUrls: ['./helper-center.component.scss']
})
export class HelperCenterComponent {

  constructor(private router: Router) { }

  isOpen = false;
  cards = [{
    title: 'Busca de facs',
    message: 'Duração: 50 segundos',
    image: 'student_hat_ico',
    link: '/facs-tour'
    }
  ];

  cardClicked(card) {
    const navigations: NavigationExtras = {
      queryParams: {helper: true}
    };
    this.router.navigate([card.link], navigations);
  }
}
